import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Books() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/books").then(({ data }) => { setBooks(data); setLoading(false); });
  }, []);

  return (
    <div data-testid="books-page" className="max-w-7xl mx-auto px-6 lg:px-12 py-10 md:py-20">
      <div className="max-w-3xl mb-16">
        <div className="overline mb-4">The Disciple Life — Bookshop</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight" style={{ color: "var(--ink)" }}>
          Books for the long obedience.
        </h1>
        <p className="mt-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--ink-2)" }}>
          Devotionals, discipleship guides, and reflections on scripture — written by Cody D. Thrash and shipped from The Disciple Life.
          Every purchase supports the writing and the ministry behind it.
        </p>
      </div>

      {loading ? (
        <p style={{ color: "var(--muted)" }}>Loading the shelf…</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
          {books.map((b) => (
            <Link
              key={b.id}
              to={`/books/${b.id}`}
              data-testid={`book-card-${b.id}`}
              className="group block"
            >
              <div className="aspect-[2/3] overflow-hidden mb-5 flex items-center justify-center" style={{ background: "var(--surface)" }}>
                <img src={b.cover_url} alt={b.title} className="w-full h-full object-contain group-hover:scale-[1.03] transition-transform duration-500" />
              </div>
              <div className="overline mb-1">{b.category}</div>
              <h3 className="font-serif-display text-2xl leading-tight" style={{ color: "var(--ink)" }}>{b.title}</h3>
              {b.subtitle && <p className="italic text-sm mt-1" style={{ color: "var(--ink-2)" }}>{b.subtitle}</p>}
              <div className="mt-4 flex items-center justify-between text-sm">
                <span style={{ color: "var(--terracotta)" }} className="font-medium">${b.price.toFixed(2)}</span>
                <span className="inline-flex items-center gap-1" style={{ color: "var(--ink-2)" }}>
                  Read more <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
